import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * CheckboxInput Component (web)
 *
 * A checkbox input with label and accessibility support for web.
 * React Native implementation is in CheckboxInput.native.tsx.
 */
import React, { forwardRef } from 'react';
import { useTheme } from '../../theme';
export const CheckboxInput = forwardRef(({ checked = false, indeterminate = false, label, error, disabled = false, onChange, 'data-testid': testId, className, id, }, ref) => {
    const theme = useTheme();
    const checkboxId = id || `checkbox-${Math.random().toString(36).substring(2, 11)}`;
    const errorId = error ? `${checkboxId}-error` : undefined;
    React.useEffect(() => {
        if (ref && typeof ref !== 'function' && ref.current) {
            ref.current.indeterminate = indeterminate;
        }
    }, [indeterminate, ref]);
    const containerStyles = {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.xs,
    };
    const labelContainerStyles = {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.sm,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
    };
    const checkboxStyles = {
        width: '20px',
        height: '20px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        accentColor: theme.colors.primary,
    };
    const labelTextStyles = {
        fontSize: theme.typography.fontSize.body,
        color: error ? theme.colors.error : theme.colors.text,
        fontFamily: theme.typography.fontFamily,
        userSelect: 'none',
    };
    const errorStyles = {
        fontSize: theme.typography.fontSize.caption,
        color: theme.colors.error,
        marginTop: theme.spacing.xs,
    };
    return (_jsxs("div", { style: containerStyles, className: className, "data-testid": testId, children: [_jsxs("label", { htmlFor: checkboxId, style: labelContainerStyles, children: [_jsx("input", { ref: ref, type: "checkbox", id: checkboxId, checked: checked, disabled: disabled, onChange: (e) => {
                            if (!disabled && onChange) {
                                onChange(e.target.checked);
                            }
                        }, "aria-invalid": !!error, "aria-describedby": errorId, style: checkboxStyles }), label && _jsx("span", { style: labelTextStyles, children: label })] }), error && (_jsx("div", { id: errorId, role: "alert", style: errorStyles, children: error }))] }));
});
CheckboxInput.displayName = 'CheckboxInput';
